var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51791 6.00619V6.46727M6.51791 18.2629V9.32376M17.4809 18.2629V12.9212C17.4791 11.8877 17.0678 10.897 16.3369 10.1662C15.6061 9.43541 14.6155 9.02407 13.582 9.02229C12.5473 9.02229 11.5549 9.43286 10.8226 10.1639C10.0904 10.8948 9.67812 11.8865 9.67635 12.9212M9.67635 12.9212V18.2629M9.67635 12.9212V9.32376M6.38464 22H17.6154C20.037 22 22 20.0369 22 17.6154V6.38463C22 3.96307 20.037 2 17.6154 2H6.38464C3.96307 2 2 3.96307 2 6.38463V17.6154C2 20.0369 3.96307 22 6.38464 22Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLine);
export default __webpack_public_path__ + "static/media/linkedin_line.e0311d212c86075fb65707c8f8cf95aa.svg";
export { ForwardRef as ReactComponent };